import { getMessaging, getToken } from 'firebase/messaging'
import { initializeApp, getApps } from 'firebase/app'

const firebaseConfig = {
  apiKey: 'AIzaSyCpuYP2a-AaXQsxz2N7Voj0f7Aoscgzz4g',
  authDomain: 'centelhr-f7933.firebaseapp.com',
  projectId: 'centelhr-f7933',
  storageBucket: 'centelhr-f7933.firebasestorage.app',
  messagingSenderId: '572702611362',
  appId: '1:572702611362:web:d7efded7d047c3d46344fb',
  measurementId: 'G-L7D3WMH9BQ',
}

let messaging

function initFirebase() {
  if (!getApps().length) {
    const app = initializeApp(firebaseConfig)
    messaging = getMessaging(app)
  }
  return messaging
}

export async function getPushNotificationToken(registration) {
  try {
    if (!registration) {
      console.error('Service worker registration missing')
      return null
    }
    const messaging = initFirebase()

    const permission = await Notification.requestPermission()
    if (permission !== 'granted') return

    const token = await getToken(messaging, {
      vapidKey:
        'BOf1NnK_Dl99njEfre6hSjplxHa_bc--x36EcjJY3QzxSvsQXpEND1ej5_t6PVMp0e0dRk1lUU25MzYYz09j_7Q',
      serviceWorkerRegistration: registration,
    })

    return token || null
  } catch (err) {
    console.error('FCM error', err)
    return null
  }
}
